import Vue from 'vue'
export default new Vue()

// 使用across组件传递信息时定义名称不能重复并说明用途
// 如'addCollect'是由Featurelist.vue发起，Aside.vue接收，目的是调用Aside.vue组件中的方法
// openFromHeader由Header.vue发起，Devops.vue.接收，目的是为打开运维客户弹框